"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anchorIcon = void 0;
// tslint:disable:max-line-length
exports.anchorIcon = "\n\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"21\" height=\"21\" viewBox=\"0 0 21 21\">\n\t\t<path fill-rule=\"evenodd\" d=\"M0 1.997C0 .894.902 0 2.01 0h8.988c.553 0 1.316.32 1.7.71L16 4.076 12.625 8.23c-.345.426-1.08.77-1.627.77h-8.99C.9 9 0 8.104 0 7.003V1.997z\"/>\n\t</svg>\n";
//# sourceMappingURL=anchor-icon.js.map